import { FC } from "react";
import { Check, X } from "lucide-react";
import {
  DEFAULT_VALIDATION_POLICY,
  getPasswordRuleChecks,
  ValidationPolicy,
} from "../../Utils/validationPolicy";

interface Props {
  password?: string | null;
  policy?: ValidationPolicy;
  className?: string;
}

/**
 * Live checklist shown under every password field so the rules are clear
 * before the user submits, not just after a rejection. Hidden entirely when
 * the password policy flag is switched off by an admin.
 */
export const PasswordPolicyHints: FC<Props> = ({ password, policy, className }) => {
  const activePolicy = policy ?? DEFAULT_VALIDATION_POLICY;
  if (!activePolicy.passwordPolicyValidationEnabled) return null;

  const value = password ?? "";
  const checks = getPasswordRuleChecks(value, activePolicy);

  return (
    <div className={`mt-2 rounded-xl border border-zinc-200 bg-zinc-50 px-3 py-2.5 dark:border-zinc-700 dark:bg-zinc-800/40 ${className ?? ""}`}>
      <p className="text-[10px] font-black uppercase tracking-widest text-zinc-500 dark:text-zinc-400">
        Password must contain
      </p>
      <ul className="mt-1.5 grid grid-cols-1 gap-1 sm:grid-cols-2">
        {checks.map((check) => (
          <li key={check.key} className="flex items-center gap-1.5 text-xs font-semibold">
            <span
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full ${
                check.met
                  ? "bg-emerald-500/15 text-emerald-500"
                  : "bg-zinc-400/15 text-zinc-400 dark:text-zinc-500"
              }`}
            >
              {check.met ? <Check size={11} strokeWidth={3} /> : <X size={11} strokeWidth={3} />}
            </span>
            <span className={check.met ? "text-emerald-600 dark:text-emerald-400" : "text-zinc-500 dark:text-zinc-400"}>
              {check.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordPolicyHints;
